module.exports = __webpack_public_path__ + "static/media/icon_busca.00a7c1f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_busca.svg
// module id = 816
// module chunks = 0